/*** IMPORTS FROM imports-loader ***/
var define = false;

export function mobileNav() {
  var hamburger = document.querySelector('.hamburger');
  var body = document.querySelector('body');

  hamburger.addEventListener('click', function () {
    hamburger.classList.toggle('is-active');
    if (body.classList.contains('navOpen')) {
      body.classList.remove('navOpen');
      setTimeout(() => {
        body.classList.add('navHidden');
      }, 500);
    } else {
      body.classList.remove('navHidden');
      body.classList.add('navOpen');
    }
  });
}
